<template>
	<div class="flex-wrapper">
		<div class="title-text">
			{{ messages.formTitle }}
			<Tag v-if="isDeleted"><DeleteOutlined /> {{ $t('baseStationStatus.deleted') }}</Tag>
		</div>
		<Badge
			v-if="isDeleted"
			status="default"
			:text="$t('baseStationStatus.deleted')"
		/>
		<template v-if="baseStationObjRef !== null">
			<Badge
				v-if="baseStationObjRef.statusData.key !== 'working'"
				:status="baseStationObjRef.statusData.badge"
				:text="$t('baseStationStatus.' + baseStationObjRef.statusData.key)" />
			<Badge
				v-else-if="baseStationObjRef.heartbeat_error_code == ''"
				class="pd-lg-left" :status="baseStationObjRef.statusLiveData.badge"
				:text="$t('baseStationStatus.' + baseStationObjRef.status_live)" />
			<Tooltip
				v-else
				placement="left"
			>
				<template #title>
					<div class="strong">{{ $t('baseStationHeartbeatErrorCode.' + baseStationObjRef.heartbeat_error_code) }}</div>
					<div v-if="baseStationObjRef.heartbeat_error_message">{{ baseStationObjRef.heartbeat_error_message }}</div>
				</template>
				<span class="ant-badge-status-text nobr">
					<InfoCircleOutlined :style="{ color: colorRed, marginInlineEnd: '4px' }" /> {{ $t('baseStationStatus.' + baseStationObjRef.status_live) }}
				</span>
			</Tooltip>
		</template>
	</div>
</template>

<script>
import { toRef, computed } from 'vue';

import { Badge, Tooltip, Tag } from 'ant-design-vue';
import { InfoCircleOutlined, DeleteOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';


export default {
	components: {
		Badge, Tooltip, Tag,
		InfoCircleOutlined, DeleteOutlined,
	},
	props: ['baseStationObj', 'baseStationDetails', 'messages'],
	setup(props) {
		const baseStationObjRef = toRef(props, 'baseStationObj');
		const baseStationDetailsRef = toRef(props, 'baseStationDetails');
		const isDeleted = computed(() => baseStationObjRef.value === null && baseStationDetailsRef.value.deleted);
		return {
			baseStationObjRef,
			isDeleted,
			colorRed: Consts.COLORS.errorDark,
		}
	}
}
</script>

<style scoped>
.title-text {
	flex: 1;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>
